<template>
  <div class="news" @click="onDetail">
    <!-- 时间 -->
    <p>{{item.createtime}}</p>
    <!-- 抬头 -->
    <p class="mutline title">
      {{item.title}}
    </p>
    <!-- 内容 -->
    <p class="mutline content">
      {{item.introduce}}
    </p>
    <i class="more"></i>
  </div>
</template>

<script>
export default {
  name: 'news',
  props: ['item'],
  methods: {
    onDetail() {
      const { id, title } = this.item;
      // this.$router.push({
      //   path: "/news/newsdetail",
      //   query: {
      //     id,
      //     title,
      //   },
      // });
      const {href} = this.$router.resolve({
        path: "/news/newsdetail",
        query: {
          id,
          title,
        },
      });
      window.open(href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  position: relative;
  padding: 15px 20px;
  transition: all 1s;
  text-align: start;
  box-sizing: border-box;
  height: 100%;
  font-size: 12px;
  cursor: pointer;
  .title {
    font-weight: 700;
    margin: 5px 0;
    -webkit-line-clamp: 2;
    text-align: justify;
  }
  .content {
    -webkit-line-clamp: 3;text-align: justify;
  }
}
.news:hover {
  transition: all 1s;
  color: white;
  background-color: rgb(4, 79, 166);
}
.more {
  position: absolute;
  width: 28px;height: 28px;
  background: url('../../../assets/image/more.png') no-repeat center center;
  right: 10px;bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/homePage/components/news.vue